<template>
  <div class="lp-client lp-client--demo">
    <div class="lp-client__content">
      <div class="lp-client__content--section-one">
        <v-row>
          <v-col class="col-9 col-md-5 offset-1 offset-md-1 show-mobile">
            <h2>{{ corporationData.name }}<br />& eu<span>reciclo</span></h2>
          </v-col>
          <v-col class="col-12 col-md-5 offset-md-1 hide-mobile">
            <h2>{{ corporationData.name }}<br />& eu<span>reciclo</span></h2>
            <p>
              Com a incrível parceria entre <b>{{ corporationData.name }}</b> e
              eu<span>reciclo</span>,
              {{ corporationData.packagesCompensatedPercentage }}% do total de
              embalagens equivalentes são recicladas. Este compromisso formaliza
              mais um passo para impulsionar a reciclagem e também gerar
              benefícios econômicos para toda a cadeia e trabalhadores
              envolvidos!
            </p>
          </v-col>
          <v-col class="col-12 col-md-3 offset-md-1">
            <v-img
              contain
              width="345px"
              :src="
                require('@/assets/images/clients-landing-pages/' +
                  corporationData.productImage)
              "
              class="hide-mobile"
            />
            <v-img
              contain
              width="250px"
              :src="
                require('@/assets/images/clients-landing-pages/' +
                  corporationData.productImage)
              "
              class="show-mobile"
            />
          </v-col>
          <v-col class="col-10 col-md-5 offset-1 offset-md-1 show-mobile">
            <p>
              Com a incrível parceria entre <b>{{ corporationData.name }}</b> e
              eu<span>reciclo</span>,
              {{ corporationData.packagesCompensatedPercentage }}% do total de
              embalagens equivalentes são recicladas. Este compromisso formaliza
              mais um passo para impulsionar a reciclagem e também gerar
              benefícios econômicos para toda a cadeia e trabalhadores
              envolvidos!
            </p>
          </v-col>
        </v-row>
        <v-row class="partnership-wrapper">
          <v-col class="col-12 col-md-3 offset-md-1">
            <h3>Uma parceria entre</h3>
          </v-col>
          <v-col class="col-12 col-md-3 offset-md-1">
            <div>
              <v-img
                contain
                width="269px"
                :src="
                  require('@/assets/images/clients-landing-pages/' +
                    corporationData.logo)
                "
              />
            </div>
          </v-col>
          <v-col class="col-12 col-md-1">
            <span
              :style="{
                color: '#26D07C',
                'text-align': 'center',
                'font-family': 'metropolismedium',
                'font-size': '64px',
                'font-style': 'normal',
                'font-weight': '700',
                'line-height': 'normal',
              }"
            >
              +
            </span>
          </v-col>
          <v-col class="col-12 col-md-3">
            <v-img
              contain
              width="269px"
              :src="
                require('@/assets/images/clients-landing-pages/eureciclo-logo.png')
              "
            />
          </v-col>
        </v-row>
      </div>
      <div class="lp-client__content--section-two">
        <v-row>
          <div class="col-12 col-md-5 left">
            <v-img
              contain
              :src="
                require('@/assets/images/clients-landing-pages/section02-img01.png')
              "
            />
            <h3>
              A cada produto<br />
              <span>vendido</span>
            </h3>
          </div>
          <div class="col-12 col-md-7 right">
            <v-img
              contain
              :src="
                require('@/assets/images/clients-landing-pages/section02-img02.png')
              "
            />
            <h3>
              Um percentual de embalagens<br /><span
                >equivalentes é reciclado</span
              >
            </h3>
          </div>
        </v-row>
      </div>
      <div class="lp-client__content--section-three">
        <v-row
          :style="{
            'background-image':
              'url(' +
              require('@/assets/images/clients-landing-pages/section03-img01.png') +
              ')',
          }"
        >
          <v-col class="col-10 col-md-5 offset-1 offset-md-6">
            <h2>O que significa?</h2>
            <v-img
              contain
              width="269px"
              :src="
                require('@/assets/images/businesses-pages/' +
                  corporationData.seal)
              "
              class="show-mobile"
              style="margin: 0 auto 40px"
            />
            <p>
              Na prática, a eu<span class="green-bold">reciclo</span> assegura
              que {{ corporationData.packagesCompensatedPercentage }}% das
              embalagens equivalentes sejam destinadas corretamente à
              reciclagem.
            </p>
            <p>
              Embalagens equivalentes significam que estamos compensando o
              impacto ambiental do nosso produto utilizando outra embalagem
              feita do mesmo material.
            </p>
            <p>
              <b>
                Por exemplo, quando uma embalagem de plástico é vendida, outra
                embalagem de plástico é reciclada, contribuindo para a economia
                circular e reduzindo a nossa pegada ambiental.
              </b>
            </p>
            <p>
              Além do cuidado com o nosso impacto, a eu<span class="green-bold"
                >reciclo</span
              >
              também garante que estamos regularizados perante a legislação do
              país de gestão de resíduos.
            </p>
            <p>Vamos juntos?</p>
          </v-col>
        </v-row>
      </div>
      <div class="lp-client__content--section-four">
        <v-row>
          <v-col
            class="col-12 col-md-10 offset-md-1 --section-four-title hide-mobile"
          >
            <h2>Como essa iniciativa impacta<br />a cadeia de reciclagem</h2>
          </v-col>
          <v-col
            class="col-10 col-md-10 offset-1 offset-md-1 --section-four-title show-mobile"
          >
            <h2>Como essa iniciativa impacta a cadeia de reciclagem</h2>
          </v-col>
        </v-row>
        <v-row class="carousel-wrapper">
          <v-col v-if="$vuetify.breakpoint.smAndDown" cols="12">
            <VueSlickCarousel v-bind="sliderSettings">
              <div
                v-for="(item, i) in sectionFourCards"
                :key="i"
                :class="'item item-' + item.color"
              >
                <v-img
                  :src="
                    require('@/assets/images/clients-landing-pages/' +
                      item.image)
                  "
                  :style="{ 'max-height': '420px', width: '100%' }"
                />
                <div class="content">
                  <h4>
                    {{ item.description[0] }}
                    <br />
                    {{ item.description[1] }}
                    <br />
                    {{ item.description[2] }}
                  </h4>
                </div>
              </div>
            </VueSlickCarousel>
          </v-col>
          <div
            v-for="(card, i) in sectionFourCards"
            :key="i"
            :class="'hide-mobile col-12 col-md-4 col-xl-3 bg-' + card.color"
            :style="{
              height: '650px',
              background: 'transparent',
            }"
          >
            <div class="box-item">
              <div
                class="list-item"
                :style="{
                  'border-radius': '30px',
                  'overflow-y': 'hidden',
                }"
              >
                <div class="--section-four-img">
                  <v-img
                    :src="
                      require('@/assets/images/clients-landing-pages/' +
                        card.image)
                    "
                    :style="{ width: '100%' }"
                  />
                  <div class="div-gradient"></div>
                </div>
                <div class="content">
                  <h4>
                    {{ card.description[0] }}
                    <br />
                    {{ card.description[1] }}
                    <br />
                    {{ card.description[2] }}
                  </h4>
                </div>
              </div>
              <div class="client__content--section-four--arrow">
                <img
                  :src="
                    require('@/assets/images/clients-landing-pages/arrow.svg')
                  "
                  alt=""
                />
              </div>
            </div>
          </div>
        </v-row>
      </div>
      <div class="lp-client__content--section-five">
        <v-row>
          <v-col class="col-10 col-md-10 offset-1 offset-md-1">
            <div class="--section-five-title">
              <h2 class="hide-mobile">
                Estamos investindo para
                <b>desenvolver a cadeia com impacto socioambiental</b>
                e aumentar as taxas de reciclagem do país!
              </h2>
              <h2 class="show-mobile">
                Estamos investindo para<br /><b
                  >desenvolver a cadeia com<br />impacto socioambiental</b
                ><br />e aumentar as taxas de<br />reciclagem do país!
              </h2>
            </div>
          </v-col>
        </v-row>
        <v-row class="--section-five-content">
          <v-col class="col-10 col-md-5 offset-1 offset-md-1 show-mobile">
            <h2>Veja o impacto que queremos alcançar!</h2>
          </v-col>
          <v-col class="col-12 col-md-4 offset-md-1">
            <div class="background-pattern">
              <img
                :src="
                  require('@/assets/images/clients-landing-pages/background-pattern.png')
                "
                alt=""
              />
              <div class="div-blur-green"></div>
            </div>
            <img
              :src="
                require('@/assets/images/clients-landing-pages/' +
                  equivalentImages[corporationData.equivalentImage])
              "
              alt=""
              :style="{
                position: 'relative',
                'z-index': 9999,
                'border-radius': '50%',
                width: '22.5em',
                height: '22.5em',
              }"
              class="single-image"
            />
          </v-col>
          <v-col class="col-10 col-md-5 offset-1 offset-md-1">
            <h2 class="hide-mobile">Veja o impacto que queremos alcançar!</h2>
            <h4 class="hide-mobile">
              Agora imagine o peso de
              {{ corporationData.equivalentWeight }}.
            </h4>
            <h4 class="show-mobile">
              <span>Agora imagine o peso de</span><br />
              {{ corporationData.equivalentWeight }}.
            </h4>
            <p>
              Este é o peso que queremos alcançar com a destinação correta de
              materiais equivalentes aos das nossas embalagens.
            </p>
            <div
              class="background-pattern d-none d-md-block"
              :style="{ float: 'right' }"
            >
              <div class="div-blur-blue"></div>
            </div>
          </v-col>
        </v-row>
      </div>
      <div class="lp-client__content--section-six">
        <v-row>
          <v-col class="col-8 col-md-12 offset-2 offset-md-0 --section-six-img">
            <div>
              <v-img
                :style="{
                  width: '9.7em',
                  height: '9.7em',
                }"
                :src="
                  require('@/assets/images/clients-landing-pages/' +
                    corporationData.logoAvatar)
                "
              />
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="col-12">
            <h2>{{ corporationData.title }}</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="col-10 col-md-8 offset-1 offset-md-2">
            <p>{{ corporationData.description }}</p>
            <div class="background-pattern">
              <div class="div-blur-blue-2"></div>
            </div>
          </v-col>
        </v-row>
      </div>
      <div class="lp-client__content--section-seven">
        <v-row>
          <v-col class="col-10 col-md-5 offset-1 offset-md-1 d-flex">
            <div class="--section-seven-descriptions">
              <h2>O selo eu<span class="blank-bold">reciclo</span></h2>
              <p>
                A eu<span class="blank-bold">reciclo</span> é um negócio de
                impacto socioambiental que, junto com as empresas e a sociedade,
                transforma a cadeia de reciclagem.
              </p>
              <p>
                Vamos juntos
                <b>transformar nossa relação com os resíduos</b> para que o
                futuro possa se transformar?
              </p>
            </div>
          </v-col>
          <v-col v-if="$vuetify.breakpoint.smAndDown" cols="12">
            <VueSlickCarousel v-bind="sliderSettings">
              <div
                v-for="(item, i) in highlightsCarouselImages"
                :key="i"
                class="item"
              >
                <v-img
                  :src="item.image"
                  :style="{ 'max-height': '350px', width: '100%' }"
                />
              </div>
            </VueSlickCarousel>
          </v-col>
          <v-col
            class="col-12 col-md-6 pa-md-0 --section-seven-content hide-mobile"
          >
            <div class="--section-seven-content-carousel">
              <div>
                <img
                  :src="
                    highlightsCarouselImages[
                      highlightsCarouselImages.length - 1
                    ].image
                  "
                  :style="{
                    'border-radius': '36px',
                    'scroll-snap-align': 'start',
                  }"
                  alt=""
                />
              </div>
              <div v-for="(carousel, i) in highlightsCarouselImages" :key="i">
                <img
                  :src="carousel.image"
                  :style="{
                    'border-radius': '36px',
                    'scroll-snap-align': 'start',
                  }"
                  alt=""
                />
              </div>
              <div>
                <img
                  :src="highlightsCarouselImages[0].image"
                  :style="{
                    'border-radius': '36px',
                    'scroll-snap-align': 'start',
                  }"
                  alt=""
                />
              </div>
              <div>
                <img
                  :src="highlightsCarouselImages[1].image"
                  :style="{
                    'border-radius': '36px',
                    'scroll-snap-align': 'start',
                  }"
                  alt=""
                />
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
    <footer>
      <v-row>
        <v-col class="col-12 col-md-10 offset-md-1 logo-wrapper">
          <div class="blank-line"></div>
          <div class="logo-div">
            <v-img
              contain
              width="272px"
              :src="
                require('@/assets/images/clients-landing-pages/logo-eureciclo-rodape.png')
              "
            />
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="col-12 col-md-3 offset-md-1 more-social-wrapper">
          <h4>Saiba mais em:</h4>
          <a class="eureciclo-link" href="https://eureciclo.com.br">
            www.eureciclo.com.br
          </a>
          <h4 class="mt-5">Redes sociais</h4>
          <ul class="social pa-0">
            <li>
              <a href=""
                ><img
                  :src="
                    require('@/assets/images/clients-landing-pages/facebook.png')
                  "
                  alt="Facebook"
              /></a>
            </li>
            <li>
              <a href=""
                ><img
                  :src="
                    require('@/assets/images/clients-landing-pages/youtube.png')
                  "
                  alt="YouTube"
              /></a>
            </li>
            <li>
              <a href=""
                ><img
                  :src="
                    require('@/assets/images/clients-landing-pages/linkedin.png')
                  "
                  alt="LinkedIn"
              /></a>
            </li>
            <li>
              <a href=""
                ><img
                  :src="
                    require('@/assets/images/clients-landing-pages/instagram.png')
                  "
                  alt="Instagram"
              /></a>
            </li>
            <li>
              <a href=""
                ><img
                  :src="
                    require('@/assets/images/clients-landing-pages/spotify.png')
                  "
                  alt="Spotify"
              /></a>
            </li>
          </ul>
        </v-col>
        <v-col class="col-12 col-md-7 offset-md-1 seals-wrapper pb-0">
          <v-img
            class="show-mobile"
            :src="
              require('@/assets/images/clients-landing-pages/logos-apoio-eureciclo-rodape-mobile.png')
            "
          />
          <v-img
            class="hide-mobile"
            :src="
              require('@/assets/images/clients-landing-pages/logos-apoio-eureciclo-rodape.png')
            "
          />
        </v-col>
      </v-row>
    </footer>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
  name: 'LpDemoClientes',
  metaInfo: {
    title: 'Lp Clientes',
  },
  components: {
    VueSlickCarousel,
  },
  data: () => ({
    sliderSettings: {
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true,
      arrows: false,
      dots: false,
      swipe: true,
      autoplay: true,
    },
    highlightsCarouselImages: [
      {
        image: require('@/assets/images/clients-landing-pages/section07-img01.png'),
      },
      {
        image: require('@/assets/images/clients-landing-pages/section07-img02.png'),
      },
      {
        image: require('@/assets/images/clients-landing-pages/section07-img03.png'),
      },
      {
        image: require('@/assets/images/clients-landing-pages/section07-img04.png'),
      },
      {
        image: require('@/assets/images/clients-landing-pages/section07-img05.png'),
      },
      {
        image: require('@/assets/images/clients-landing-pages/section07-img06.png'),
      },
    ],
    intervalId: null,
    corporationData: {
      name: '[Nome da empresa]',
      packagesCompensatedPercentage: '[X]',
      equivalentWeight: '[X bolas de futebol]',
      equivalentImage: 'soccer',
      title: '[Titulo do cliente]',
      description:
        '[Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla suscipit nec arcu id finibus. Quisque id auctor mauris. Nulla fringilla turpis ullamcorper felis finibus aliquet sed dignissim lectus. Quisque nec urna ut felis elementum semper. Sed tincidunt turpis a velit efficitur, ac pharetra lectus sollicitudin. Sed leo lorem, vulputate in lorem sed, dignissim dictum nulla. Pellentesque diam tellus, mollis ac fringilla quis, malesuada a ipsum. Pellentesque rhoncus finibus eleifend. Vivamus sapien lorem, laoreet in magna sed, faucibus interdum tortor. Nam egestas eleifend imperdiet. Donec dictum felis vel libero porta convallis. Etiam eget accumsan velit. Phasellus porta magna et metus pretium varius/].dignissim dictum nulla. Pellentesque diam tellus, mollis ac fringilla quis, malesuada a ipsum. Pellentesque rhoncusa.',
      productImage: 'demo/client-demo-product-v2.png',
      logo: 'demo/logo-client-demo.png',
      logoAvatar: 'demo/logo-client-demo-square.png',
      seal: 'stamp-100.png',
    },
    equivalentImages: {
      soccer: 'section05-img01.png',
      plane: 'section05-img02.png',
      statue: 'section05-img03.png',
    },
    sectionFourCards: [
      {
        description: [
          'Gerando renda',
          'e emprego para mais',
          'profissionais de reciclagem',
        ],
        image: 'section04-img01.png',
        color: 'orange',
      },
      {
        description: [
          'Gerando renda para',
          'operadores e organizações',
          'de catadores parceiros',
        ],
        image: 'section04-img02.png',
        color: 'blue',
      },
      {
        description: [
          'Destinando corretamente',
          'toneladas de resíduos',
          'em todo o Brasil',
        ],
        image: 'section04-img03.png',
        color: 'green',
      },
    ],
  }),
  computed: {},
  mounted() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    this.intervalId = setInterval(() => {
      const carousel = document.querySelector(
        '.--section-seven-content-carousel',
      );

      if (!carousel) {
        return;
      }

      const positionOfFirstChild = 537;
      const leftover = 300;
      let positionOfNextImg = carousel.scrollTop + positionOfFirstChild;
      const heightImg = positionOfFirstChild + leftover;
      const heightLimit = carousel.scrollHeight - heightImg;

      if (heightLimit < positionOfNextImg) {
        carousel.scrollTo({
          top: positionOfFirstChild,
          behavior: 'instant',
        });

        const imgSecondPosition = positionOfFirstChild * 2;
        positionOfNextImg = imgSecondPosition;
      }

      carousel.scrollTo({
        top: positionOfNextImg,
        behavior: 'smooth',
      });
    }, 2500);
  },
  methods: {},
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.hide-mobile
  display: block !important

.show-mobile
  display: none !important

@media screen and (max-width: 959px)
  .hide-mobile
    display: none !important

  .show-mobile
    display: block !important

.lp-client
  padding-top: 100px
  font-size: 16px
  @media (min-width: $sm)
    font-size: 18px
  @media (min-width: $md)
    font-size: 19px
  @media (min-width: $xs)
    font-size: 20px
  @media screen and (max-width: 959px)
    overflow-x: hidden !important
  .blank-bold
    font-family: 'metropolismedium'
    font-weight: 700
    color: #FFF
  .green-bold
    font-family: 'metropolismedium'
    font-weight: 700
    color: #26D07C
  &__content
    &--section-one
      h2
        font-family: 'metropolisbold' !important
        color: #00313C
        font-size: 60px
        font-style: normal
        font-weight: 700
        line-height: 1
        text-align: left
        margin-bottom: 50px
        span,
        ::v-deep span
          color: #26D07C
          font-family: 'metropolisextra_bold' !important
      p
        max-width: 588px
        font-family: 'metropolisregular' !important
        color: #00313C
        font-size: 1.15em
        font-style: normal
        font-weight: 400
        line-height: 1.4
        text-align: justify
        b
          font-family: 'metropolisbold' !important
          font-weight: 700
        span,
        ::v-deep span
          color: #26D07C
          font-family: 'metropolisbold' !important
          font-weight: 700
      h3
        color: #00313C
        font-family: 'metropolisbold' !important
        font-size: 1.8em
        font-style: normal
        font-weight: 700
        line-height: 1
      .partnership-wrapper
        display: flex
        // justify-content: space-between
        align-items: center
        padding-top: 30px
        margin-bottom: 45px

      @media screen and (max-width: 959px)
        h2
          font-size: 36px !important
          text-align: center !important
          line-height: 50px !important
        p
          font-size: 16px !important
          line-height: 27px
        .v-image
          margin: 0 auto
        .partnership-wrapper
          text-align: center
          h3
            font-size: 24px !important
            margin-bottom: 20px
          .v-image
            max-width: 230px

    &--section-two
      .left
        display: flex
        flex-direction: row
        align-items: center
        justify-content: center
        background: rgba(38,208,124,1)
        padding: 13px 14px 24px 37px
        div
          max-width: 7.9em
          max-height: 7.9em
        h3
          font-family: 'metropolisregular' !important
          margin-left: 33px
          color: var(--color-text-primary, #00313C)
          font-size: 1.8em
          font-style: normal
          font-weight: 600
          line-height: 46px
          span
            font-size: 1.77em
            line-height: 58.5px
            letter-spacing: 3.84px
      .right
        display: flex
        flex-direction: row
        align-items: center
        justify-content: center
        background: rgba(0,49,60,1)
        padding: 25px 60px
        div
          max-width: 7.15em
          max-height: 7.15em
        h3
          font-family: 'metropolisregular' !important
          margin-left: 42px
          color: var(--color-text-secundary, #FFF)
          font-size: 1.8em
          font-style: normal
          font-weight: 600
          line-height: 46px
          letter-spacing: 1.5px
          span
            font-size: 1.19em
            font-weight: 600
            line-height: 56px
            letter-spacing: 3.1px
      @media screen and (max-width: 959px)
        .left, .right
          flex-flow: column
          padding: 50px 0
          gap: 20px
          h3
            margin: 0
        .left
          h3
            line-height: 46px
            span
              line-height: 52px
        .right
          h3
            font-size: 26px
            margin: 0 100px
            text-align: center
            span
              font-size: 36px
    &--section-three
      > div
        background-position-y: -80px
        background-size: 55%
        padding: 10px
        padding-bottom: 150px
        @media screen and (max-width: $sm)
          background-image: none !important
          padding-bottom: 0
        @media screen and (min-width: 1440px)
          background-position-y: -40px
          background-size: 60%
          padding-bottom: 0px
        @media screen and (min-width: 1660px)
          background-position-y: -50px
          background-size: 50%
          padding-bottom: 0
        @media screen and (min-width: 1820px)
          background-position-y: -40px
          background-size: 43%
          padding-bottom: 40px
        @media screen and (min-width: 2400px)
          background-position-y: -10px
          background-size: 30%
          padding-bottom: 40px
        h2
          color: var(--color-text-primary, #00313C)
          font-size: 3em
          font-family: 'metropolismedium' !important
          font-style: normal
          font-weight: 700
          line-height: 66px
          margin-top: 150px
          margin-bottom: 75px
        p
          color: var(--color-text-primary, #00313C)
          text-align: justify
          font-family: 'metropolisregular' !important
          font-size: 1.15em
          font-style: normal
          font-weight: 400
          line-height: 38px
          margin-bottom: 50px
          b
            font-family: 'metropolismedium'
            font-weight: 700
      @media screen and (max-width: 959px)
        > div
          h2
            font-size: 36px
            margin-top: 24px
            margin-bottom: 32px
            text-align: center
          p
            font-size: 16px
            line-height: 25px
            margin-bottom: 30px
    &--section-four
      background: #FFF
      .--section-four-title
          color: #00313C
          text-align: center
          font-family: 'metropolismedium'
          line-height: 66px
          padding-top: 40px
          padding-bottom: 100px
          h2
            font-size: 3em
      .carousel-wrapper
        background: linear-gradient(180deg, #FFF 0%, #FFF 10%, #D9D9D9 10%, #D9D9D9 57.5%, #00313C 57.5%, #00313C 100%)
        justify-content: center
        padding: 0px 5.6vw
        .client__content--section-four--arrow
          position: relative
          height: 0
          width: 100%
          display: flex
          flex-direction: row
          justify-content: center
          align-items: center
          opacity: 1
          transition: 0.2s
          @keyframes float
            0%
              transform: translatey(30px)
            50%
              transform: translatey(10px)
            100%
              transform: translatey(30px)
          img
            width: 73.999px
            height: 98px
            transform: translatey(30px)
            animation: float 4s ease-in-out infinite
        .bg-orange,
        .bg-blue,
        .bg-green
          padding-left: 1.39vw
          padding-right: 1.39vw
        .bg-orange
          .content
            background: #F4633A
          .div-gradient
            background: linear-gradient(180deg, rgba(217, 217, 217, 0.00) 0%, rgba(237, 129, 99, 0.74) 55.21%, #F4633A 100%)
        .bg-blue
          .content
            background: #147BD1
          .div-gradient
            background: linear-gradient(180deg, rgba(217, 217, 217, 0.00) 0%, rgba(106, 164, 213, 0.56) 55.73%, #147BD1 100%)
        .bg-green
          .content
            background: #26D07C
          .div-gradient
            background: linear-gradient(180deg, rgba(217, 217, 217, 0.00) 0%, rgba(102, 211, 157, 0.64) 51.04%, #26D07C 100%)
        .list-item
          padding: 0px
          background: transparent
          .--section-four-img
            position: relative
            .div-gradient
              position: absolute
              bottom: 0px
              left: 0px
              // height: 0%
              height: 30%
              width: 100%
              transition: height 0.5s
          .content
            display: flex
            align-items: center
            justify-content: center
            bottom: 0
            left: 0
            width: 100%
            height: 0px
            transition: 0.5s
            overflow: hidden
            padding: 0px
            h4
              color: #FFF
              text-align: center
              font-family: 'metropolismedium'
              font-size: 1.2em
              font-style: normal
              font-weight: 600
              line-height: 40px
        .box-item:hover
          // .div-gradient
          //   height: 30%
          .content
            padding: 0px 20px 0px 20px
            height: 170px
          .client__content--section-four--arrow
            opacity: 0
      @media screen and (max-width: 959px)
        .carousel-wrapper
          background: linear-gradient(180deg, #FFF 0%, #FFF 35%, #D9D9D9 35%, #D9D9D9 87.5%, #00313C 87.5%, #00313C 100%)
          padding: 0px 5.6vw
          .v-image
            min-height: 450px !important
        .--section-four-title
          padding-top: 0
          padding-bottom: 30px
          h2
            text-align: center
            font-size: 34px
            font-style: normal
            font-weight: 700
            line-height: 50px
        .item
          position: relative
          .v-image,
          .content
            border-radius: 30px
          .content
            position: absolute
            display: flex
            justify-content: center
            align-items: flex-end
            width: 100%
            height: 100%
            top: 0
            left: 0
            h4
              color: #ffffff
              font-size: 20px
              line-height: 1.4
              text-align: center
              padding-bottom: 40px
          &-orange
            .content
              background: #F4633A
              background: linear-gradient(180deg, rgba(217, 217, 217, 0.00) 50%, rgba(237, 129, 99, 0.74) 75%, #F4633A 100%)
          &-blue
            .content
              background: #147BD1
              background: linear-gradient(180deg, rgba(217, 217, 217, 0.00) 50%, rgba(106, 164, 213, 0.56) 75%, #147BD1 100%)
          &-green
            .content
                background: #26D07C
                background: linear-gradient(180deg, rgba(217, 217, 217, 0.00) 50%, rgba(102, 211, 157, 0.64) 75%, #26D07C 100%)
    &--section-five
      padding-top: 20px
      background: #00313C
      .--section-five-title
        display: flex
        align-items: center
        justify-content: center
        padding: 33px 75px
        flex-shrink: 0
        border-radius: 30px
        border: 7px solid #26D07C
        background: #FFF
        h2
          color: #00313C
          text-align: center
          font-family: 'metropolisregular'
          font-size: 1.8em
          font-style: normal
          font-weight: 600
          line-height: 46px
          b
            font-weight: 700
            font-family: 'metropolismedium'
      .--section-five-content
        padding-top: 135px
        padding-bottom: 180px
        .background-pattern
          position: relative
          height: 0
          width: 0
          img
            position: absolute
            top: -341px
            left: -200px
          .div-blur-green
            position: absolute
            top: -264px
            left: -400px
            width: 619px
            height: 619px
            border-radius: 619px
            background: rgba(38, 208, 124, 0.50)
            background-blend-mode: color-dodge
            filter: blur(257px)
          .div-blur-blue
            position: absolute
            top: 0
            left: -80px
            width: 173px
            height: 472px
            border-radius: 472px
            background: var(--cores-complementares-azul, #147BD1)
            background-blend-mode: color-dodge
            filter: blur(257px)
        h2
          // letter-spacing: 1.5px
          color: var(--color-text-secundary, #FFF)
          font-family: 'metropolismedium'
          font-size: 3em
          font-style: normal
          font-weight: 700
          line-height: 66px
          text-align: justify
          max-width: 545px
        h4
          margin-top: 50px
          color: var(--color-text-secundary, #FFF)
          text-align: justify
          font-family: 'metropolisregular'
          font-size: 1.6em
          font-style: normal
          font-weight: 600
          line-height: 46px
          letter-spacing: 1px
        p
          margin-top: 50px
          margin-bottom: 0px
          color: var(--color-text-secundary, #FFF)
          font-family: 'metropolisregular'
          font-size: 1.15em
          font-style: normal
          font-weight: 400
          line-height: 38px
          text-align: justify
      @media screen and (max-width: 959px)
        position: relative
        padding-top: 80px
        overflow: hidden
        &::before,
        &::after
          background-image: url('~@/assets/images/clients-landing-pages/background-pattern.png')
          background-repeat: no-repeat
          background-position: center center
          background-size: contain
          content: ""
          position: absolute
          display: block
          width: 145px
          height: 620px
          top: 40%
          left: -15%
        &::after
          right: -15%
          left: inherit
          transform: rotateY(180deg)
        .--section-five-title
          padding: 30px 10px
          h2
            font-size: 20px
            line-height: 1.8
        .--section-five-content
          padding-top: 100px
          padding-bottom: 80px
          h2
            font-size: 35px
            text-align: center
          h4
            text-align: center
            font-size: 26px
            line-height: 32px
            span
              font-size: 20px
          p
            text-align: center
            font-size: 16px
            line-height: 27px
          .background-pattern
            display: none
        .single-image
          display: block
          max-width: 275px
          max-height: 275px
          margin: 0 auto
      @media screen and (min-width: 1620px)
        padding-top: 50px
      @media screen and (min-width: 1740px)
        padding-top: 80px
      @media screen and (min-width: 1860px)
        padding-top: 100px
      @media screen and (min-width: 1920px)
        padding-top: 120px
      @media screen and (min-width: 2000px)
        padding-top: 140px
      @media screen and (min-width: 2400px)
        padding-top: 100px
    &--section-six
      padding-top: 160px
      padding-bottom: 100px
      .--section-six-img
        display: flex
        align-items: center
        justify-content: center
        > div
          padding: 3.2em
          background: #FFF
          border: 14px solid #000,
          border-radius: 50%,
      h2
        margin-top: 55px
        color: var(--color-text-primary, #00313C)
        text-align: center
        font-family: 'metropolismedium'
        font-size: 3em
        font-style: normal
        font-weight: 700
        line-height: 66px
      p
        color: var(--color-text-primary, #00313C)
        text-align: center
        font-family: 'metropolisregular'
        font-size: 1.15em
        font-style: normal
        font-weight: 400
        line-height: 38px
        margin-top: 20px
      .background-pattern
        position: relative
        height: 0
        width: 0
        .div-blur-blue-2
          position: absolute
          top: 0
          left: -630px
          width: 472px
          height: 472px
          border-radius: 472px
          background: var(--cores-complementares-lilas, #6F7BD4)
          background-blend-mode: color-dodge
          filter: blur(257px)
      @media screen and (max-width: 959px)
        padding-top: 60px
        padding-bottom: 60px
        .--section-six-img
          > div
            max-width: 100%
            padding: 3em
            .v-image
              width: 100% !important
              height: 100% !important
        h2
          font-size: 36px
          margin-top: 30px
        p
          font-size: 16px
          line-height: 27px
    &--section-seven
      background: var(--cores-verde-verde-950, #26D07C)
      .--section-seven-descriptions
        margin-top: auto
        margin-bottom: auto
        h2
          color: var(--color-text-primary, #00313C)
          font-family: 'metropolismedium'
          font-size: 3em
          font-style: normal
          font-weight: 700
          line-height: 66px
          margin-bottom: 35px
        p
          color: var(--color-text-primary, #00313C)
          text-align: justify
          font-family: 'metropolisregular'
          font-size: 1.15em
          font-style: normal
          font-weight: 400
          line-height: 38px
          margin-bottom: 35px
          b
            font-family: 'metropolismedium'
          &:last-of-type
            margin-bottom: 0
      .--section-seven-content-carousel
        overflow-y: hidden
        scroll-snap-type: y mandatory
        scroll-padding-top: 100px
        display: grid
        width: 100%
        gap: 10px
        height: 800px
        text-align: end
      @media screen and (max-width: 959px)
        padding-top: 50px
        .slick-slider
          padding: 45px 12px 20px
          .v-image
            border-radius: 30px
        .--section-seven-descriptions
          h2
            font-size: 36px
            text-align: center
          p
            line-height: 27px
        .--section-seven-content-carousel
          width: calc(100% - 24px)
          margin: 0 auto
          img
            max-width: 100%
  footer
    background: #00313C
    padding-top: 75px
    .logo-wrapper
      display: flex
      flex-direction: row
      align-items: center
      margin-bottom: 25px
      .blank-line
        background: #26D07C
        width: 100%
        height: 1px
      .logo-div
        width: min-content
        margin-left: 8.3333333333%
    .more-social-wrapper
      h4
        color: var(--color-text-secundary, #FFF)
        font-family: 'metropolismedium'
        font-size: 1.6em
        font-style: normal
        font-weight: 700
        line-height: 46px
      .eureciclo-link
        color: #26D07C
        font-family: 'metropolismedium'
        font-size: 1.2em
        font-style: normal
        font-weight: 700
        line-height: 46px
        text-decoration-line: underline
      .social
        li
          display: inline-block
          list-style-type: none
          text-align: center
          padding: 10px
          &:first-of-type
            padding-left: 0
          &:last-of-type
            padding-right: 0
    .seals-wrapper
      .v-image
        ::v-deep
          .v-image__image
            background-position: right bottom !important
            background-size: auto
    @media screen and (max-width: 959px)
      .logo-wrapper
        flex-flow: column-reverse
        gap: 30px
        .blank-line
          width: 70%
        .logo-div
          margin-left: 0
          .v-image
            width: 214px !important
      .more-social-wrapper
        text-align: center
        .social
          li
            padding-bottom: 0
      .seals-wrapper
        background-color: #ffffff
        padding-bottom: 70px !important
        .v-image
          ::v-deep
            .v-image__image
              background-position: center center !important
              background-size: 120%
</style>
